import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 16.7536V8.24643C3 7.91586 3.13439 7.59882 3.37361 7.36507C3.61283 7.13132 3.93728 7 4.27558 7H15.4803C15.8186 7 16.143 7.13132 16.3823 7.36507C16.6215 7.59882 16.7559 7.91586 16.7559 8.24643V16.7536C16.7559 17.0841 16.6215 17.4012 16.3823 17.6349C16.143 17.8687 15.8186 18 15.4803 18H4.27558C3.93728 18 3.61283 17.8687 3.37361 17.6349C3.13439 17.4012 3 17.0841 3 16.7536ZM15.4803 9.49286H9.05904H4.27558V16.7536H15.4803V9.49286Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M15 6V5H5V6"
      stroke={props.color || 'currentColor'}
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
    <path
      d="M13 3V2H7V3"
      stroke={props.color || 'currentColor'}
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDemostacking = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDemostacking;
